import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import ErrorBoundary from '../components/common/ErrorBoundary';
import { LoginModal, RegisterModal, ChangePasswordModal } from '../components';
import IndexPage from './IndexPage';
import CompanyPage from './CompanyPage';
import RealEstatePage from './RealEstatePage';
import ArchiPage from './ArchiPage';
import OthersPage from './OthersPage';
import MyPage from './user/MyPage';
import UserManagementPage from './admin/UserManagementPage';

import { logError } from '../utils/errorHandler';

const App: React.FC = () => {
  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    // エラーログの記録
    logError(error, { 
      componentStack: errorInfo.componentStack,
      route: window.location.pathname 
    });
  };

  return (
    <ErrorBoundary onError={handleError}>
      <Layout>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/realestate" element={<RealEstatePage />} />
          <Route path="/archi" element={<ArchiPage />} />
          <Route path="/others" element={<OthersPage />} />
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/admin/users" element={<UserManagementPage />} />

        </Routes>
        
        {/* 認証モーダル */}
        <LoginModal />
        <RegisterModal />
        <ChangePasswordModal />
      </Layout>
    </ErrorBoundary>
  );
};

export default App;
